import { useEffect, useState } from "react";
import PropTypes from "prop-types";

// @mui material components
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 React components
import MDInput from "components/MDInput";

import { nganHangApi } from "api/nganHang";
import { timNganHangTheoTen } from "lib/vietQrChuyenKhoan";

function ChonNganHang({ value, onChange, label, required }) {
  const [danhSach, setDanhSach] = useState([]);

  useEffect(() => {
    nganHangApi
      .danhSach()
      .then(setDanhSach)
      .catch(() => setDanhSach([]));
  }, []);

  const chon = timNganHangTheoTen(value, danhSach);

  return (
    <Autocomplete
      options={danhSach}
      getOptionLabel={(o) => o.name ?? o.shortName ?? ""}
      isOptionEqualToValue={(o, v) => o.code === v.code}
      value={chon}
      onChange={(_, val) => onChange(val?.name ?? val?.shortName ?? "")}
      renderInput={(params) => <MDInput {...params} label={label} fullWidth required={required} />}
    />
  );
}

ChonNganHang.defaultProps = {
  value: "",
  label: "Tên ngân hàng",
  required: false,
};

ChonNganHang.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
};

export default ChonNganHang;
